import { get } from "lodash";
import supported from "./supported.json";
import transformLocale from "./transformLocale";
import makeOptions from "./getSupportedLocaleOptions";
import getDeviceLocale from "./getDeviceLocale";
export { makeOptions };
export var DEFAULT_LANG = "en-GB";
/** @author: Richard Scoones
 *  @desc: As lang files are stored remotely We need to make sure we only make requests for languages we currently support.
 *         This file will allow for optional dialect's but request base lanauge if not supported.
 */
export default (function (rawLocale) {
    if (rawLocale === void 0) { rawLocale = getDeviceLocale(); }
    var locale = transformLocale(rawLocale || getDeviceLocale());
    var language = locale.split("-")[0];
    var foundDialect = get(supported, language + "." + locale);
    if (foundDialect) {
        return locale;
    }
    // if we can find the lanuage, use the default Dialect
    var foundLanguage = get(supported, "" + language);
    if (foundLanguage) {
        return foundLanguage.default;
    }
    if (global && !global.__IS_TEST__) {
        console.warn("[Content]: \"" + locale + "\" not supported, default to \"" + DEFAULT_LANG + "\"");
    }
    return DEFAULT_LANG;
});
